import { useCallback, useState } from 'react';

import type { PageParams, SortParam } from './types';

type State = PageParams & { sort?: SortParam };

/**
 * In-memory twin of `useTableState` with an identical return shape, backed by
 * `useState` instead of the URL. Use for nested/detail tables whose paging and
 * sort must live in component memory rather than the URL (ADR-0016).
 */
export function useTableMemoryState(defaultPageSize = 25) {
  const [state, setState] = useState<State>({
    page: 1,
    pageSize: defaultPageSize,
    sort: undefined,
  });
  const update = useCallback(
    (next: Partial<State>) => setState((prev) => ({ ...prev, ...next })),
    [],
  );
  return { ...state, setState: update };
}
